import { render, staticRenderFns } from "./RelatorioUsuarioForm.vue?vue&type=template&id=3dbc0222&scoped=true&"
import script from "./RelatorioUsuarioForm.vue?vue&type=script&lang=js&"
export * from "./RelatorioUsuarioForm.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioUsuarioForm.vue?vue&type=style&index=0&id=3dbc0222&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbc0222",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VSwitch,VTextField})
